var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export var useAlertStore = create()(devtools(function (set) { return ({
    alerts: [],
    addAlert: function (alert) {
        return set(function (state) { return ({ alerts: __spreadArray(__spreadArray([], state.alerts, true), [alert], false) }); });
    },
    removeAlert: function (alert_index) {
        return set(function (state) { return ({
            alerts: state.alerts.filter(function (n, i) { return i !== alert_index; }),
        }); });
    },
}); }));
